/* eslint-disable */

import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import './button.css';

/**
 * Button UI component
 */
const Button = forwardRef(
  ({ variant, label, disabled, type, onClick, className, ...props }, ref) => {
    const variantClass = variant ? `pds-button--${variant}` : undefined;

    return (
      <button
        {...props}
        type={type}
        className={['pds-button', variantClass, className].join(' ').trim()}
        disabled={disabled}
        onClick={onClick}
        ref={ref}
      >
        {label}
      </button>
    );
  },
);

Button.propTypes = {
  /**
   * Which variant of button to render
   */
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'tertiary',
    'subtle',
    'critical',
  ]),
  /**
   * The text of the button
   */
  label: PropTypes.node.isRequired,
  /**
   * Is the button disabled?
   */
  disabled: PropTypes.bool,
  /**
   * Type of button
   */
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  /**
   * Click event handler callback
   */
  onClick: PropTypes.func.isRequired,
};

Button.defaultProps = {
  variant: 'secondary',
  type: 'button',
  disabled: false,
};

export default Button;
